import { useUser } from "./useUser";
import { useLocale } from "./useLocale";
import { useAuth } from "./useAuth";
import detectBrowserLanguage from "detect-browser-language";

/**
 * Hook for getting the current language
 * @returns {string} The current language based on user preference, locale, or browser detection
 */
export function useLang(): string {
  const { user } = useUser();
  const { isAuthenticated } = useAuth();
  const { locale } = useLocale();
  const { lang } = user || {};

  return (
    (isAuthenticated ? lang : locale) ||
    localStorage.getItem("languageSelect") ||
    detectBrowserLanguage()?.split("-")[0] ||
    "en"
  );
}
